import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { format } from 'date-fns';
import Icon from '../../../components/AppIcon';

const AlertsCard = ({ alerts = [] }) => {
  const { t } = useTranslation();
  const recentAlerts = useMemo(() => {
    return alerts
      .slice()
      .sort((a, b) => new Date(b.created_at) - new Date(a.created_at))
      .slice(0, 5);
  }, [alerts]);

  return (
    <div className="bg-card rounded-lg border border-border p-4 md:p-6 lg:p-8 shadow-elevation-sm">
      <div className="flex items-center gap-2 mb-4 md:mb-6">
        <Icon name="Bell" size={22} className="text-warning" />
        <h2 className="text-xl md:text-2xl font-semibold text-foreground">
          {t('candidateProfile.alerts')}
        </h2>
      </div>

      {recentAlerts.length > 0 ? (
        <div className="space-y-2">
          {recentAlerts.map((alert) => (
            <div key={alert.id} className="bg-muted/50 rounded-lg p-3 md:p-4 border border-border">
              <p className="text-xs md:text-sm text-foreground leading-relaxed">
                {alert.description}
              </p>
              <p className="text-xs text-muted-foreground mt-1">
                {alert.created_at
                  ? format(new Date(alert.created_at), 'dd-MM-yyyy')
                  : ''}
              </p>
            </div>
          ))}
        </div>
      ) : (
        <p className="text-sm md:text-base text-muted-foreground">
          {t('candidateProfile.noAlerts')}
        </p>
      )}
    </div>
  );
};

export default AlertsCard;
